module.exports = __webpack_public_path__ + "static/img/organilog-landing.fc2a2a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/organilog-landing.png
// module id = 125
// module chunks = 0